import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { UserService } from 'src/app/_services/user.service';
import { User } from 'src/app/_models/user';
import { ProjectService } from 'src/app/_services/project.service';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DOCUMENT, JsonPipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationDialogService } from 'src/app/test/test-step/confirmation-dialog.service';
import { SettingService } from 'src/app/_services/setting.service';
import { TestService } from 'src/app/_services/test.service';
import { UserMgmtService } from 'src/app/_services/user-mgmt.service';
import { environment } from 'src/environments/environment';
import { MatMenuTrigger } from '@angular/material/menu';
import { saveAs } from "file-saver";
import { UrlService } from 'src/app/_services/url.service';
import { Subscription } from 'rxjs';
import { data } from 'jquery';
import { beatBlipSubscriptionConsts } from 'src/app/consts/beatBlipSubscriptionConsts';
import { MemoryService } from 'src/app/_services/memory.service';
import { HomeService } from "src/app/_services/home.service";

@Component({
  selector: 'app-start',
  templateUrl: './start.component.html',
  styleUrls: ['./start.component.scss']
})
export class StartComponent implements OnInit {
  headerOptions = {
    showSetting : false,
    showSearch: true,
    heading : "",
    data: undefined,
  }
  currentUser: User;
  projectData: any;
  projectDetailFlag: boolean;
  locationRedirectFlag: number = 0;
  currentProjectData: any;
  currentProjectName: any = '';
  sharedUsers : any;
  submitted: boolean;
  projectRenameForm: UntypedFormGroup;
  projectDataForRename: { projectName: any; id: any; };
  url: any;
  projectdataById: any;
  iconForSelectedProject: string;
  colorForSelectedProject: string;
  projectId: any;
  enableAddition: boolean;
  projectdata: any;
  objectForTopNavBar: {
    projectId: string,
    enableMenu: boolean
    enableSerachBar: boolean
  }
  moduleCount: any;
  fileName: string;
  customerName: string;
  previousUrl: any;
  subscription: Subscription;
  copiedTestSuite: any;
  isTestSuiteCopied: boolean = false;
  selectedIcon: string = "AI";
  selectedColor: string = "Light Grey";
  defaultIconColor: string = "Light Grey";
  // iconNames =  Object.keys(beatBlipSubscriptionConsts.iconList);
  // iconList = beatBlipSubscriptionConsts.iconList;
  // iconClasses  = Object.values(beatBlipSubscriptionConsts.iconList);
  iconNames:any;
  iconList:any;
  iconClasses:any;
  imageList:any;
  imageNames:any;
  imagePath:any;
  colorList = beatBlipSubscriptionConsts.colorList;
  colorNames = Object.keys(beatBlipSubscriptionConsts.colorList);
  imagesJson = beatBlipSubscriptionConsts.images;
  iconsJson = beatBlipSubscriptionConsts.icons;
  agentCheck : boolean;
   ADOCheck =  localStorage.getItem('isADOEnabled') == 'true' ? true : false;
  allDeletedProjects: any;
  allProjects: any;
  projectDetails: any;

  constructor(private userService: UserService,
    private project: ProjectService,
    private route: ActivatedRoute,
    private toastrService: ToastrService,
    private cookieService: CookieService,
    private elRef: ElementRef,
    private http: HttpClient,
    private formBuilder: UntypedFormBuilder,
    private usermgmt: UserMgmtService,
    private router: Router,
    private setting: SettingService,
    private testService: TestService,
    private urlService:UrlService,
    private testCase:TestService,
    private memoryService: MemoryService,
    private homeService: HomeService,
    private confirmationDialogService: ConfirmationDialogService,
    // private _FileSaverService: FileSaverService,
    @Inject(DOCUMENT) private document: Document) {
    this.url = environment.baseUrl;
    this.subscription = this.project.getProjectData().subscribe(
      (data) => {
        if(data){
          this.getAllProjectData();
        }
      }
    )
  }

  @ViewChild('cancelProjectRenamemodal', null) cancelProjectRenamemodal: ElementRef;
  @ViewChild('cancelUpdateDescriptionmodal', null) cancelUpdateDescriptionmodal: ElementRef;
  
  @ViewChild(MatMenuTrigger, null) contextMenu: MatMenuTrigger;
  contextMenuPosition = { x: "0px", y: "0px" };
  ngOnInit() {
    //set header details
    this.homeService.setHeaderOptions(this.headerOptions);

    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    console.log("current timezone ", timeZone)

    this.memoryService.getAgentCheck().subscribe(
      (res)=>{
        this.agentCheck = res;
      }
    )

    if(this.agentCheck)
    {
      this.memoryService.setSelectedProject(null);
      this.memoryService.setAllProjectsData([]);
      this.memoryService.setUrlHistory([]);
      this.memoryService.getCurrentUser().subscribe((res)=>
      {
        if(res == null)
        {
          this.userService.getUser().subscribe((data) => {
            this.currentUser = data;
            this.customerName = this.currentUser.name;
            this.memoryService.setCurrentUser(data);
          })
        }
        else
        {
          this.currentUser = res;
          this.customerName = this.currentUser.name;
        }
      })
    }
    else
    {
      localStorage.removeItem("selectedProject");
      localStorage.removeItem('allProjects');
      localStorage.removeItem('urlHistory');
      if(!JSON.parse(localStorage.getItem('currentUser'))) {
        this.userService.getUser().subscribe((data) => {
          this.currentUser = data;
          this.customerName = this.currentUser.name;
        }
        )
      }
      else{
        this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
        this.customerName = this.currentUser.name;
      }
    }

    this.project.setLocatorView(false);
    // this.project.loadSuggestion.next(true);

   
    this.getAllImages();
    this.getAllIcons();
    this.getAllProjectData();
    this.testCase.setView(true)
    this.initAllForms();
    this.loadCopiedTestSuite();

    this.urlService.resetUrl();
  };

  getAllProjectData() {
    if(this.agentCheck)
    {
      this.memoryService.getAllProjectsData().subscribe((res)=>
      {
        if(res.length > 0)
        {
            this.projectData = res;
        }
        else
        {
          this.project.getAllProjects().subscribe((data) => {
              this.projectData = data['project'];
              this.memoryService.setAllProjectsData(data['project']);
            }
          )
        }
      })

    }
    else
    {
      if(JSON.parse(localStorage.getItem('allProjects'))){
        this.projectData = JSON.parse(localStorage.getItem('allProjects'));
      }
      else{
        this.project.getAllProjects().subscribe(
          (data) => {
            this.projectData = data['project'];
            localStorage.setItem('allProjects', JSON.stringify(this.projectData));
          }
        )
      }
    }


  }
  initAllForms() {
    this.projectRenameForm = this.formBuilder.group({
      rename: [ "",  [Validators.required, Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)]  ],
      comment : [""]
    });
    let addNewField = this.ADOCheck ? this.projectRenameForm.addControl('adoIntId', this.formBuilder.control('')) : this.projectRenameForm.removeControl('adoIntId');
  }

  hideProjectDetails() {
    $('.hl-projectListContainer').removeClass('hl-has-visible-scrollbar');
    $('.hl-projectListWrapper').removeClass('d-flex');
    $('.hl-projectDetailsContainer').hide();
    // $('.hl-projectListItem').removeClass('active') ;
    this.locationRedirectFlag = 0;
    if(this.agentCheck)
    {
      this.memoryService.setSelectedProject(null);
    }
    else
    {
      localStorage.removeItem('selectedProject');
    }

    this.project.sendMessage(undefined);
    this.currentProjectName = undefined;
  }

  showSlider()
  {
    let items = document.querySelectorAll('.hl-dvUserCarousal .carousel .carousel-item')

    items.forEach((el) => {
        const minPerSlide = items.length > 4 ?  4 : items.length;
        let next = el.nextElementSibling
        for (var i=1; i<minPerSlide; i++) {
            if (!next) {
                // wrap carousel by using first child
              next = items[0]
            }
            let cloneChild = next.cloneNode(true)
            el.appendChild(cloneChild['children'][0])
            next = next.nextElementSibling
        }
    })
  }

  showProjectDetails(projectData) {
    this.projectdataById = projectData;
	this.project.getProjectDetailsById(this.projectdataById.id).subscribe(
    // this.project.getProjectById(this.projectdataById.id).subscribe(
      (res: any) => {
        console.log('res',res);
        this.projectDetails = res;

        console.log("date details : ", this.projectDetails, this.projectDetails.lastModifiedBy)
        this.projectdataById = res['project'];
        this.moduleCount = res['moduleCount'];
        this.currentProjectData = res['project'];
        this.currentProjectName = this.currentProjectData.projectName;
        this.sharedUsers = res['sharedUser'] ? res['sharedUser'] : undefined; 
        this.iconForSelectedProject = res['project']['iconName'] ? res['project']['iconName'] : 'fas fa-robot';
        this.colorForSelectedProject =  res['project']['color'] ?  res['project']['color'] : 'Grey';

        if(this.sharedUsers)
        {
          $('.hl-projectListItem').removeClass('active');
          $('.hl-projectListContainer').addClass('hl-has-visible-scrollbar');
          $('.hl-projectListWrapper').addClass('d-flex');
          $('.hl-projectDetailsContainer').show();
          setTimeout(()=>
          {
            this.showSlider();
          }, 0)
        }
        this.locationRedirectFlag++;
        if(this.agentCheck)
        {
          this.memoryService.setSelectedProject(this.projectdataById);
        }
        else
        {
          localStorage.setItem("selectedProject", JSON.stringify(this.projectdataById));
        }

        let obj = JSON.parse(JSON.stringify(this.projectdataById));
        obj["projectId"] = this.projectdataById.id;
        this.project.sendMessage(this.projectdataById.id);
        // if (this.locationRedirectFlag > 1) {
        //   this.locationRedirectFlag = 0;
        //   this.router.navigate(['/project/module/' + this.projectdataById.id])
        // }
       

      }
    )


  }

  renameProject() {
    console.log(this.currentProjectData);
    
    this.selectedColor = this.colorForSelectedProject;
    // this.selectedIcon = Object.keys(this.iconList).find(key => this.iconList[key] === this.iconForSelectedProject);
    this.selectedIcon = this.imageNames.find(key => this.imageList[key] === this.iconForSelectedProject);
    if(!this.selectedIcon) {
      this.selectedIcon = this.iconNames.find(key => this.iconList[key] === this.iconForSelectedProject);
    }
    this.projectDataForRename = {
      projectName: this.currentProjectName.trim(),
      id: this.currentProjectData.id
    };

    this.projectRenameForm.patchValue({
      rename: this.currentProjectName.trim(),
      comment: this.currentProjectData?.description
    });

    if(this.ADOCheck)
    {
      this.projectRenameForm.get('adoIntId').patchValue(this.currentProjectData?.adoIntId);
    }
  }

  onRenameProject() {    
    this.submitted = true;
    if (this.projectRenameForm.invalid) {
      return;
    }
    var objFormval = this.projectRenameForm.value;
    console.log(objFormval);
    var nameCheck = this.projectData.find((f)=>f.projectName==objFormval.rename && this.projectdataById.id != f.id) ? true : false;
    if(nameCheck){
      this.toastrService.clear();
      this.toastrService.error('Automation Name already exists');
      return;
    }
    if(objFormval.rename.includes('%')){
      this.toastrService.clear();
      this.toastrService.warning('% can not be used in the Automation Name');
      return;
    }
    var iconName = "";

    if(this.imageList[this.selectedIcon]) {
      iconName = this.imageList[this.selectedIcon];
    }else {
      iconName = this.iconList[this.selectedIcon];
    }

    const ValueForRename = {
      iconName: iconName,
      color:  this.selectedColor,
      description: objFormval.comment,
      projectName: objFormval.rename.trim(),
      id: this.projectDataForRename["id"],
    };

    if(this.ADOCheck)
    {
      ValueForRename['adoIntId'] =  objFormval.adoIntId;
    }

    if (!/^[^:|*?<>/\\"]+$/.test(ValueForRename.projectName)) {
      this.toastrService.clear();
      this.toastrService.warning("Automation Name is not Valid");
      return;
    }

    this.http
      .put(this.url + "/HuLoopRest/huloop/project", ValueForRename)
      .subscribe((data) => {
        if (data) {
          // alert('Project renamed successfully');
          this.toastrService.success("Automation Updated Successfully");
          this.http.post(this.url+"/HuLoopRest/huloop/access/update-restricted-project/"+this.currentProjectName+"/"+ValueForRename.projectName,null)
          .subscribe((res) => {
              this.showProjectDetails(this.projectdataById);
          });
          this.currentProjectName = ValueForRename.projectName;
          if(this.agentCheck)
          {
            this.memoryService.setAllProjectsData([]);
          }
          else
          {
            localStorage.removeItem('allProjects');
          }
          this.getAllProjectData();
          this.showProjectDetails(this.projectdataById);
          this.project.loadSuggestion.next(true);
          this.cancelProjectRenamemodal.nativeElement.click();

        }
      });
  }

  removeProject() {
    var title = this.currentProjectName;
    var id = this.currentProjectData.id;
    this.confirmationDialogService
      .openConfirmDialog("Are you sure you want to delete " + title + " ?")
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          this.project.deleteProjectById(id).subscribe((data) => {
            this.toastrService.clear();
            this.toastrService.success("Automation deleted successfully");
            // this.http.get(this.url+"/HuLoopRest/huloop/access/delete-restricted-project/"+this.currentProjectName)
            // .subscribe((res) => {
                
            // });
            this.hideProjectDetails()
            if(this.agentCheck)
            {
              this.memoryService.setAllProjectsData([]);
            }
            else
            {
              localStorage.removeItem('allProjects');
            }
            this.getAllProjectData();

          });
        }
      });
  }
  onContextMenu(event: MouseEvent, treedata) {
    console.log(treedata);
    
    event.preventDefault();
    this.contextMenuPosition.x = event.clientX + "px";
    this.contextMenuPosition.y = event.clientY + "px";
    this.contextMenu.menuData = { item: treedata };
    this.contextMenu.menu.focusFirstItem("mouse");
    this.contextMenu.openMenu();
    //console.log(treedata, 'onContext', this.contextMenu.menuData);
  }

  addParentModule(parentModule) {
    //console.log(parentModule)
    this.confirmationDialogService
      .openParentModulePopUp(parentModule)
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          setTimeout(() => {
            //console.log('parent', this.projectId);
            // this.getAllChildTestDir(this.projectId);
            // this.toastrService.clear();
            // this.toastrService.success( ' Module Added successfully');
          }, 2000);
        }
      });
  }

  addModulefromProject(item) {
    //console.log('addtestSuitfromProject')
    this.confirmationDialogService
      .openAddtestSuitPopUp(item, "Add")
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          // this.getAllChildTestDir(this.projectId);
          // this.project.loadSuggestion.next(true);
          //console.log('Afdd', this.projectId);
        }
      });
    //console.log('AddModule')
  }

  prjExportFile(projectId, Pname, item?:any) {
    console.log(item);
    if(item.iconName){

    if(item.iconName.includes('.png')){
      let icon = item.iconName.replace('.png','');
      this.fileName = Pname + '_-_' + item.color + '_-_' + icon + ".zip";
    }
    else{

      this.fileName = Pname + '_-_' + item.color + '_-_' + item.iconName + ".zip";
    }
    
  }
  else{
    this.fileName = Pname + ".zip";
  }
    
    //console.log(Pname);
    
    //console.log(this.fileName);

    var uploadUrl =
      this.url + "/HuLoopRest/huloop/projectExport/export/" + projectId;
    this.toastrService.clear();
    this.toastrService.success(
      'Exporting Automation...&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i class="fa fa-circle-o-notch fa-spin"></i></i>',
      null,
      {
        extendedTimeOut: 0,
        timeOut: 0,
        enableHtml: true,
      }
    );
    this.http
      .post(uploadUrl, null, {
        headers: {
          accept: "application/octet-stream",
        },
        responseType: "arraybuffer",
      })
      .subscribe((response) => {
        // var fileName = headers('Content-Disposition').split(";")[1].trim().split("=")[1];
        // fileName = fileName.replace(/"/g, '');
        var data = new Blob([response], {
          type: "application/octet-stream",
        });
        saveAs(data, this.fileName);
        this.toastrService.clear();
        this.toastrService.success("Automation exported successfully");
      });
  }

  prjInformationExportFile(projectId) {
    var uploadUrl =
      this.url + "/HuLoopRest/huloop/projectExport/exportInfo/" + projectId;
    this.toastrService.clear();
    this.toastrService.success(
      'Preparing automation information...&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i class="fa fa-circle-o-notch fa-spin"></i></i>',
      null,
      {
        extendedTimeOut: 0,
        timeOut: 0,
        enableHtml: true,
      }
    );
    this.http
      .post(uploadUrl, null, {
        headers: {
          accept: "application/octet-stream",
        },
        responseType: "arraybuffer",
      })
      .subscribe((response) => {
        //                            var fileName = headers('Content-Disposition').split(";")[1].trim().split("=")[1];
        //                            fileName = fileName.replace(/"/g, '');
        //                            var data = new Blob([response], {
        //                                type: 'application/octet-stream'
        //                            });
        //                            FileSaver.saveAs(data, fileName);
        this.toastrService.clear();
        this.toastrService.success("you will receive email shortly");
      });
  }

  loadCopiedTestSuite() {
    this.project.subjectforTestSuite.subscribe((suite) => {
      this.isTestSuiteCopied = suite ? true : false;
      if (this.isTestSuiteCopied) {
        this.copiedTestSuite = suite;
      } else {
        this.copiedTestSuite = undefined;
      }
    });
  }

  pasteSuiteIntoProject(item) {
    console.log("working...", item);
    console.log(this.copiedTestSuite);
    if (this.copiedTestSuite.projectId != item.id) {
      this.toastrService.clear();
      this.toastrService.warning("Cannot paste in another project");
      return;
    }
    this.testService
      .pasteSuite(item.id, item.id, this.copiedTestSuite.id)
      .subscribe((data) => {
        //console.log(data);
        // this.getAllChildTestDir(this.projectId);
        this.toastrService.clear();
        this.toastrService.success("Suite pasted successfully");
      });
  }

  getAllImages() {
    console.log("inside getAllImages...");
    try {
      this.http.get('assets/automation-images/images.json').subscribe(images => {
        this.imageList = images;
        this.imageNames = Object.keys(images);
        
        this.imageNames.forEach(key => {
          this.imageList[key] = "assets/automation-images/"+images[key];
        });
        
        this.imagePath = Object.values(images);
        
      }, error => {
        console.log("Error: ", error);
      });
    } catch (error) {

    }

  }

  getAllIcons() {
    console.log("inside getAllIcons...");
    try {
      this.http.get('assets/automation-images/icons.json').subscribe(icons => {
        this.iconList = icons;
        this.iconNames = Object.keys(icons);
        this.iconClasses  = Object.values(icons);
  
      }, error=>{
        console.log("Error: ", error);
      });
    } catch (error) {

    }

  }
  projectRestore(projectId){
    this.project.restoreFiles(projectId,null).subscribe(
      (data)=>{
        this.toastrService.clear();
        this.toastrService.success('Automation Restores successfully');
        this.getAllProjectData();
      }
    )
  }
  getAllDeletedProjects(){
    this.project.getAllDeletedProjects().subscribe(
      (data)=>{
        console.log(data);
        
        this.allProjects = data['project'];
        this.allDeletedProjects = this.allProjects.filter((f)=>f.isDeleted == "true")
         console.log(this.allDeletedProjects);
 
      }
    )
  }
  restoreDeletedAutomation(prjectData){
    this.http
    .put(this.url + "/HuLoopRest/huloop/project/restore", prjectData)
    .subscribe((data) => {
      if (data) {
        this.currentProjectName = prjectData.projectName;
        // alert('Project renamed successfully');
        this.toastrService.success("Automation Resoterd Successfully");
        // this.http.post(this.url+"/HuLoopRest/huloop/access/update-restricted-project/"+this.currentProjectName+"/"+prjectData.projectName,null)
        // .subscribe((res) => {
        //     // this.showProjectDetails(this.projectdataById);
        // });
        if(this.agentCheck)
        {
          this.memoryService.setAllProjectsData([]);
        }
        else
        {
          localStorage.removeItem('allProjects');
        }
        this.getAllProjectData();
        // this.showProjectDetails(this.projectdataById);
        this.project.loadSuggestion.next(true);
        // this.cancelProjectRenamemodal.nativeElement.click();

      }
    });
  }
}
